import { withSvgIcon } from './withSvgIcon';

export const Coins = withSvgIcon(
  <>
    <path
      d="M7 15.0508C5.76281 15.682 5 16.5466 5 17.5003C5 19.4333 8.13401 21.0003 12 21.0003C15.866 21.0003 19 19.4333 19 17.5003C19 16.5466 18.2372 15.682 17 15.0508"
      stroke="currentColor"
      strokeWidth="currentWidth"
    />
    <path
      d="M7 10.0508C5.76281 10.682 5 11.5466 5 12.5003C5 14.4333 8.13401 16.0003 12 16.0003C15.866 16.0003 19 14.4333 19 12.5003C19 11.5466 18.2372 10.682 17 10.0508"
      stroke="currentColor"
      strokeWidth="currentWidth"
    />
    <ellipse
      cx="12"
      cy="7.5"
      rx="7"
      ry="3.5"
      stroke="currentColor"
      strokeWidth="currentWidth"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
